import React from 'react'
import { Wrapper } from './index.styled'
import NotesHistoryPanel from './NotesHistoryPanel'
import NotesListPanel from './NotesListPanel'
import NotesViewPanel from './NotesViewPanel'
import { useNotesScreen } from './useNotesScreen'

export default function NotesScreen() {
  useNotesScreen()

  return (
    <Wrapper>
      <NotesListPanel />
      <NotesViewPanel />
      <NotesHistoryPanel />
    </Wrapper>
  )
}
